import { createFileRoute, notFound } from "@tanstack/react-router";

import LandingNotFound from "@/components/landing/LandingNotFound";
import LandingPageView from "@/components/landing/LandingPageView";
import { landingPageContent } from "@/content/landing/source";
import { cmsPageHead, cmsPageHeaders } from "@/routing/cmsPageRoute";

/** The comparisons, the product pages and the six one-offs, from one route. */
export const Route = createFileRoute("/$landing/")({
  loader: async ({ params }) => {
    const page = await landingPageContent({ data: `/${params.landing}` });
    if (!page) {
      throw notFound();
    }
    return page;
  },
  headers: cmsPageHeaders,
  head: cmsPageHead,
  component: LandingRoute,
  notFoundComponent: LandingNotFound,
});

function LandingRoute() {
  return <LandingPageView page={Route.useLoaderData()} />;
}
